/**
 * App Download Configuration
 *
 * Configure download links for different platforms.
 * Set environment variables or update this file with actual links.
 */

const appDownloadConfig = {
  ios: {
    appStoreUrl: process.env.REACT_APP_IOS_APP_STORE_URL || 'https://itunes.apple.com/app/mypatientspace/id1443558006?mt=8',
    deepLink: process.env.REACT_APP_IOS_DEEP_LINK || 'mypatientspace://',
    bundleId: 'com.mypatientspace.mypatientspace',
    enabled: true, // Set to false to hide iOS option
  },
  android: {
    playStoreUrl: process.env.REACT_APP_ANDROID_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.mypatientspace.mypatientspace',
    deepLink: process.env.REACT_APP_ANDROID_DEEP_LINK || 'mypatientspace://',
    packageName: 'com.mypatientspace.mypatientspace',
    enabled: true, // Set to false to hide Android option
  },
  pwa: {
    url: window.location.origin,
    enabled: true, // Set to false to hide PWA option
  },
  features: {
    showQRCodes: true,
    showInstructions: true,
    enableAnalytics: true,
    enableDeepLinking: true,
    enableSocialSharing: false,
  }
};

export default appDownloadConfig;
